import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import ApiService from "../../../Services/user/service";
import Swal from "sweetalert2";

const Withdraw = () => {
  const navigate = useNavigate();
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;
  const currency = localStorage.getItem("currentCurrency") ?? "1"; // 1 is INR, 0 is USD

  const [userdetails, setUserdetails] = useState({});
  const [bankDetails, setBankDetails] = useState([]);
  const [amount, setAmount] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchuserdetails();
    fetchBankDetails();
  }, []);

  const fetchuserdetails = async () => {
    try {
      const res = await ApiService.getUserDetail(user_id);
      setUserdetails(res?.data?.data[0] || {});
    } catch (err) {
      console.log(err);
    }
  };

  const fetchBankDetails = async () => {
    try {
      const res = await ApiService.getUserBank({ userId: user_id });
      setBankDetails(res?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  let availableBalance = 0;
  if (userdetails && Object.keys(userdetails).length > 0) {
    if (currency === "1") {
      availableBalance = userdetails.Inr_Balance || 0;
    } else {
      availableBalance = userdetails.Balance || 0;
    }
  }

  // Find primary bank account, or fall back to the first available bank details
  const activeBank = bankDetails.find((b) => b.isPrimary) || bankDetails[0];

  const handleAmountClick = (val) => {
    setAmount(Number(amount || 0) + val);
  };

  const handleSubmit = async () => {
    if (!amount || Number(amount) <= 0) {
      Swal.fire({ icon: "error", title: "Invalid Amount", text: "Please enter a valid withdrawal amount" });
      return;
    }
    if (Number(amount) > availableBalance) {
      Swal.fire({ icon: "error", title: "Insufficient Balance", text: "You do not have enough funds to withdraw this amount" });
      return;
    }
    if (!activeBank) {
      Swal.fire({
        icon: "warning",
        title: "No Bank Details",
        text: "Please add a bank account before making a withdrawal",
        showCancelButton: true,
        confirmButtonText: "Add Bank Account",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/user/bank-details");
        }
      });
      return;
    }

    setIsSubmitting(true);
    const payload = {
      userid: user_id,
      Balance: Number(amount),
      type: 0, // 0 = withdraw
      transactionId: "",
      ScreenShot: "",
      governmentDocs: "",
    };

    try {
      if (currency === "1") {
        await ApiService.withdrawalDepositInr(payload);
      } else {
        await ApiService.withdrawalDeposit(payload);
      }
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Withdrawal request submitted successfully",
        timer: 1500,
        showConfirmButton: false,
      });
      navigate(-1);
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Failed", text: "Withdrawal request failed" });
    } finally {
      setIsSubmitting(false);
    }
  };

  const isINR = currency === "1";
  const symbol = isINR ? "₹" : "$";

  return (
    <div className="mobile-withdraw-container">
      <style>
        {`
          .mobile-withdraw-container {
            background-color: #ffffff;
            color: #000000;
            font-family: 'Inter', sans-serif;
            // padding: 20px;
            border-radius: 8px;
            box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
            margin: 20px;
          }

          .withdraw-header {
            display: flex;
            align-items: center;
            padding: 20px 15px;
            background-color: #9d2c2c;
            color: white;
            font-size: 1.25rem;
            font-weight: 600;
          }

          .withdraw-content {
            padding: 10px 5px;
          }

          .balance-card {
            background-color: #f8f9fa;
            border: 1px solid #eee;
            border-radius: 12px;
            padding: 15px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 25px;
          }

          .balance-card span {
            font-size: 1rem;
            color: #666;
          }

          .balance-card h4 {
            margin: 0;
            font-size: 1.2rem;
            color: #000;
            font-weight: bold;
          }

          .input-group-custom {
            position: relative;
            margin-bottom: 15px;
          }

          .input-group-custom span {
            position: absolute;
            left: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: #888;
            font-size: 1.2rem;
          }

          .input-group-custom input {
            width: 100%;
            background-color: #f8f9fa;
            border: 1px solid #ddd;
            border-radius: 10px;
            padding: 15px 15px 15px 40px;
            color: #000;
            font-size: 1.1rem;
            outline: none;
          }

          .amount-chips {
            display: flex;
            gap: 10px;
            margin-bottom: 25px;
          }

          .amount-chip {
            flex: 1;
            background-color: #e04a4a;
            color: white;
            border: none;
            border-radius: 8px;
            padding: 10px;
            font-size: 0.9rem;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.2s;
          }

          .amount-chip:hover {
            background-color: #c03939;
          }

          .bank-info-section {
            background-color: #fcfcfc;
            border: 1px solid #e9ecef;
            border-radius: 12px;
            padding: 18px;
            margin-bottom: 25px;
          }

          .bank-info-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
            border-bottom: 1px solid #f1f3f5;
            padding-bottom: 10px;
          }

          .bank-info-header h5 {
            margin: 0;
            font-size: 1rem;
            font-weight: 600;
            color: #495057;
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .bank-row {
            display: flex;
            margin-bottom: 10px;
            font-size: 0.9rem;
          }

          .bank-row:last-child {
            margin-bottom: 0;
          }

          .bank-label {
            color: #6c757d;
            width: 160px;
            flex-shrink: 0;
          }

          .bank-value {
            color: #212529;
            font-weight: 600;
            word-break: break-all;
          }

          .no-bank-card {
            background-color: #fff9db;
            border: 1px solid #ffe066;
            border-radius: 12px;
            padding: 20px;
            margin-bottom: 25px;
            text-align: center;
          }

          .no-bank-card p {
            margin: 0 0 12px 0;
            color: #f59f00;
            font-size: 0.95rem;
          }

          .add-bank-btn {
            background-color: #f59f00;
            color: white;
            border: none;
            border-radius: 8px;
            padding: 8px 16px;
            font-weight: 600;
            font-size: 0.85rem;
            cursor: pointer;
          }

          .submit-btn {
            width: 100%;
            background-color: #9d2c2c;
            color: white;
            border: none;
            border-radius: 10px;
            padding: 15px;
            font-size: 1.1rem;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.2s;
          }

          .submit-btn:hover {
            background-color: #832424;
          }

          .submit-btn:disabled {
            background-color: #ced4da;
            cursor: not-allowed;
          }
        `}
      </style>

      {/* HEADER */}
      <div className="withdraw-header">
        <Icons.ArrowLeft size={24} onClick={() => navigate(-1)} style={{ cursor: "pointer", marginRight: "15px" }} />
        <span>Withdraw Funds</span>
      </div>

      <div className="withdraw-content">
        <div className="balance-card">
          <span>Available Balance</span>
          <h4>{symbol} {availableBalance.toFixed(2)}</h4>
        </div>

        <label className="form-label fw-bold mb-2">Enter Withdrawal Amount ({isINR ? "INR" : "USD"})</label>
        <div className="input-group-custom">
          <span>{symbol}</span>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="amount-chips">
          {isINR ? (
            <>
              <button className="amount-chip" onClick={() => handleAmountClick(5000)}>+ {symbol}5,000</button>
              <button className="amount-chip" onClick={() => handleAmountClick(10000)}>+ {symbol}10,000</button>
              <button className="amount-chip" onClick={() => handleAmountClick(25000)}>+ {symbol}25,000</button>
            </>
          ) : (
            <>
              <button className="amount-chip" onClick={() => handleAmountClick(100)}>+ {symbol}100</button>
              <button className="amount-chip" onClick={() => handleAmountClick(500)}>+ {symbol}500</button>
              <button className="amount-chip" onClick={() => handleAmountClick(1000)}>+ {symbol}1000</button>
            </>
          )}
        </div>

        {activeBank ? (
          <div className="bank-info-section">
            <div className="bank-info-header">
              <h5><Icons.CheckCircle size={18} className="text-success" /> Receiving Bank Account</h5>
              {activeBank.isPrimary && <span className="badge bg-success">Primary</span>}
            </div>
            
            <div className="bank-row">
              <div className="bank-label">Bank Name:</div>
              <div className="bank-value">{activeBank.bankName}</div>
            </div>
            <div className="bank-row">
              <div className="bank-label">Holder Name:</div>
              <div className="bank-value">{activeBank.accountHolderName}</div>
            </div>
            <div className="bank-row">
              <div className="bank-label">Account Number:</div>
              <div className="bank-value">{activeBank.bankAccountNo}</div>
            </div>
            <div className="bank-row">
              <div className="bank-label">IFSC Code:</div>
              <div className="bank-value">{activeBank.bankIfsc}</div>
            </div>
            {activeBank.upiId && (
              <div className="bank-row">
                <div className="bank-label">UPI ID:</div>
                <div className="bank-value">{activeBank.upiId}</div>
              </div>
            )}
          </div>
        ) : (
          <div className="no-bank-card">
            <p>You have not registered any bank accounts yet.</p>
            <button className="add-bank-btn" onClick={() => navigate("/user/bank-details")}>
              Add Bank Account
            </button>
          </div>
        )}

        <button 
          className="submit-btn" 
          onClick={handleSubmit} 
          disabled={isSubmitting || !activeBank}
        >
          {isSubmitting ? "Submitting..." : "Submit Withdraw"}
        </button>
      </div>
    </div>
  );
};

export default Withdraw;
